// scroll-top.js

/* eslint-disable no-invalid-this */

$(document).ready(function() {
  $(window).scroll(function() {
    if ($(this).scrollTop() > 100) {
      $('#js_top').fadeIn();
    } else {
      $('#js_top').fadeOut();
    }
  });

  $('#js_top').click(function() {
    $('html, body').animate({scrollTop: 0}, 800);
    return false;
  });
});

//
// EOF
//
